/**
 * Modules
 */

/**
 * Expose isFunction
 */

module.exports = isFunction['default'] = isFunction

/**
 * isFunction
 */

function isFunction (value) {
  return typeof value === 'function'
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/is-function/lib/index.js
// module id = ./node_modules/@f/is-function/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons